//(function () {
//	'use strict';

//    const module = angular.module('imApp');

//    module.component('businessSite', {
//        templateUrl: 'views/components/views/businessSite/businessSite.template.html?v=' + module.version,
//		controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'translateService', 'modalService', 'businessSiteService', 'logisticService', function ($stateParams, stateService, utilityService, translateService, modalService, businessSiteService, logisticService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let businessSiteKeyno = $stateParams.businesssite_keyno;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                edit: {},
//                selectListBusinessCompanies: [],
//                itemsListStockPlaces: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTIONS

//            async function loadEdit() {
//                vm.model.edit = (await businessSiteService.getEdit({ businesssite_keyno: businessSiteKeyno }))[0];

//                return loadStockPlaces();
//            }

//            async function loadCompanies() {
//                vm.model.selectListBusinessCompanies = await logisticService.listCompanies();
//            }

//            async function loadStockPlaces() {
//                if (utilityService.validateParmsValue(vm.model.edit.businesssite_keyno) !== true) return;

//                if (vm.model.edit.businesssite_keyno > 0) {
//                    return vm.model.itemsListStockPlaces = await businessSiteService.listStockPlaces({ businesssite_keyno: vm.model.edit.businesssite_keyno });
//                }
//            }
            
//            // #endregion LOAD PROCEDURE FUNCTIONS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                businessSiteService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//                loadCompanies();
//            }

//            // #endregion ON INIT FUNCTION

//		}]
//	});
//})();
